/** @format */

import React from 'react';
import { useCarouselDots } from './useDotsCarousel';
import { DotsContainer, Dot } from './GalleryCarouselDots.style';

type GalleryCarouselDotsProps = {
  currentSlide: number;
  totalPhotos: number;
};

export const GalleryCarouselDots: React.FC<GalleryCarouselDotsProps> = ({ currentSlide, totalPhotos }) => {
  const { getActiveDotIndex, shouldShowDots, getDotsCount } = useCarouselDots();

  if (!shouldShowDots(totalPhotos)) {
    return null;
  }

  const dotsCount = getDotsCount(totalPhotos);
  const activeDotIndex = getActiveDotIndex(currentSlide, totalPhotos);

  return (
    <DotsContainer>
      {Array.from({ length: dotsCount }).map((_, index) => (
        <Dot key={index} active={index === activeDotIndex} />
      ))}
    </DotsContainer>
  );
};
